import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface State {
  myMeals: Array<any>;
}

const initialState: State = {
  myMeals: [],
};

const slice = createSlice({
  name: 'myMealsSlice',
  initialState,
  reducers: {
    setMyMeals(state, action: PayloadAction<any>) {
      const { payload } = action;
      const existsIndex = state.myMeals.findIndex((item) => item.uri === payload.uri);
      if (existsIndex !== -1) {
        state.myMeals.splice(existsIndex, 1);
      } else {
        state.myMeals = [payload, ...state.myMeals].slice(0, 20);
      }
    },
  },
});

export default slice.reducer;

export const { setMyMeals } = slice.actions;
